import {
  PUBLICREPORT,
} from 'actions/publicReport';
import {reducerPackage} from "../../utils";

export const publicReportList = reducerPackage(PUBLICREPORT);
